<app-page-title title="Frequência"></app-page-title>

<section class="report">
  <div class="report-btn" [routerLink]="['/frequencia/relatorio']">
    <img src="../../../assets/icons/report.svg" width="25" />
    <span>Relatório</span>
  </div>
</section>

<app-no-data
  *ngIf="!frequencies"
  title="Sem dados"
  subtitle=" Nenhuma estudo cadastrado, para fazer frequencia"
></app-no-data>

<cdk-virtual-scroll-viewport
  itemSize="32"
  class="viewport"
  *ngIf="frequencies"
  (scrolledIndexChange)="scroll($event)"
  (elementRef)="elementRef($event)"
>
  <!--   <div *ngFor="let frequency of frequenciesPending">
    <app-frequency-card [frequency]="frequency"></app-frequency-card>

        [routerLink]="['/frequencia/add']"
    [queryParams]="{ groupWordId: frequency.group_word_id, groupId: frequency.group_id }"
  </div> -->
  <div
    *ngFor="let frequency of frequencies"
    class="frequency-container"
    [routerLink]="frequency.frequency_id ? ['/frequencia/vizualizar/' + frequency.frequency_id] : ['/frequencia/add']"
    [queryParams]="
      !frequency.frequency_id ? { groupWordId: frequency.group_word_id, groupId: frequency.group_id } : null
    "
  >
    <p class="title">
      <mat-icon *ngIf="frequency.frequency_id">check_circle</mat-icon> {{ frequency.name }} - {{ frequency.theme }}
    </p>
    <div class="details">
      palavra cadastrada em:
      <span>{{ frequency.created_at | date: 'dd/M/yyyy ' }}</span>
      <span *ngIf="frequency.frequency_finished">Finalizada</span>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
